import './AgentPanel.css';
import { HudCorners } from '../effects/HudCorners.js';

/**
 * אזור הזהות (סעיף 5): תמונת סוכן 003 + תווית, חץ מונפש כלפי מטה,
 * תמונת סוכן 013 + תווית. שתי התמונות הן assets אמיתיים מהפרויקט.
 *
 * סוכן מיוחד 003 תמיד מוצג כ"מזוהה" — הוא לא עובר סריקה (לבקשת המשתמש: 003
 * הוא דמות הפיקוד, לא הסוכן שמזדהה מול המערכת בכל משימה).
 * סוכן 013 (פלג) הוא זה שמציג SCANNING עד לזיהוי הראשון, ואז נשאר "מזוהה"
 * ברציפות לכל משך חיי האפליקציה (identified מגיע מ-MissionScreen).
 */
export function AgentPanel({
  animationsEnabled,
  identified,
}: {
  animationsEnabled: boolean;
  identified: boolean;
}) {
  return (
    <aside className="agent-panel term-panel" aria-label="זיהוי סוכנים">
      <div className="agent-panel__header">
        <span>זיהוי סוכנים // ARCHIVE</span>
        <span className="agent-panel__link mono" role="status">
          <span className={`status-dot ${identified ? 'status-dot--available' : 'status-dot--locked'}`} />
          {identified ? 'LINK' : 'SCANNING'}
        </span>
      </div>
      <div className="agent-panel__body">
        <AgentCard
          src="/agents/agent-003.webp"
          alt="סוכן מיוחד 003"
          name="סוכן מיוחד 003"
          tag="VERIFIED"
          verified
          animationsEnabled={animationsEnabled}
        />

        <div className={`agent-arrow ${animationsEnabled ? 'agent-arrow--bounce' : ''}`} aria-hidden="true">
          <svg width="22" height="34" viewBox="0 0 22 34" fill="none">
            <path d="M11 1v28M11 29l-8-8M11 29l8-8" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <AgentCard
          src="/agents/agent-013.webp"
          alt="סוכן 013"
          name="סוכן 013"
          tag={identified ? 'ACTIVE' : 'SCANNING…'}
          verified={identified}
          animationsEnabled={animationsEnabled}
        />
      </div>
    </aside>
  );
}

function AgentCard({
  src,
  alt,
  name,
  tag,
  verified,
  animationsEnabled,
}: {
  src: string;
  alt: string;
  name: string;
  tag: string;
  verified: boolean;
  animationsEnabled: boolean;
}) {
  const stateClass = verified ? 'is-verified' : 'is-scanning';
  return (
    <figure className={`agent-card ${stateClass}`}>
      <div className={`agent-card__frame ${animationsEnabled ? 'agent-card__frame--scan' : ''}`}>
        <img src={src} alt={alt} loading="eager" />
        <HudCorners />
      </div>
      <figcaption className="agent-card__label mono">
        {name}
        <span className="agent-card__tag">{tag}</span>
      </figcaption>
    </figure>
  );
}
